import { createSlice } from '@reduxjs/toolkit';
import client from 'api/apiClient';
import { createAsyncThunkWrapper } from 'redux/thunk/createAsyncThunkWrapper';
import { HistorySpHeaders, HistoryState } from 'types/history';

const initialState: HistoryState = {
    records: [],
    totalCount: 0,
    lastTithe: null,
    loading: false,
    error: null,
};

export const fetchHistory = createAsyncThunkWrapper<any, HistorySpHeaders>('history/fetchHistory', async (headers: HistorySpHeaders) => {
    const response: any = await client.get('/historySP', { headers });
    return {
        trxHistories: response?.trxHistories || [],
        totalCount: response?.totalRecords || 0,
        offset: headers.offset,
    };
});

const historySlice = createSlice({
    name: 'historySlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchHistory.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(fetchHistory.fulfilled, (state, action) => {
            state.loading = false;
            if (!action?.payload) return;
            const { trxHistories, totalCount, offset } = action.payload;
            state.records = trxHistories;
            state.totalCount = totalCount;
            if (offset === 0) {
                // assigning to null when one use has history but then we fetch the history of another user and that user
                // do not have history so we need clear the previous data
                state.lastTithe = trxHistories?.[0] || null;
            }
        });
        builder.addCase(fetchHistory.rejected, (state, action) => {
            state.loading = false;
            state.error = action?.error?.message || null;
        });
    },
});
export default historySlice.reducer;
